// Filtros da Pesquisa CT-e (PO1-2968): definição para a URL (utils/filtrosUrl)
// e opções dos selects. Sem React.
import { filtrosAtivos } from "../../../utils/filtrosUrl";
import { chaveCompleta, chaveParcial } from "../../../utils/periodoPesquisa";

export const TETO_DIAS = 90;
export const PAGE_SIZES = [25, 50, 100];

export const ORDENACAO = ["emissao", "importacao", "numero", "transportadora", "valorFrete", "valorMercadoria"];

export const DEFINICAO_FILTROS = {
  tipoData: { padrao: "emissao", tipo: "enum", opcoes: ["emissao", "importacao"] },
  dataInicial: { padrao: "", tipo: "texto" },
  dataFinal: { padrao: "", tipo: "texto" },
  chave: { padrao: "", tipo: "texto" },
  numero: { padrao: "", tipo: "texto" },
  serie: { padrao: "", tipo: "texto" },
  transportadoraId: { padrao: null, tipo: "inteiro", min: 1 },
  tipo: { padrao: "", tipo: "enum", opcoes: ["0", "1", "2", "3"] },
  situacao: { padrao: "", tipo: "enum", opcoes: ["cancelado", "ativo"] },
  chaveNf: { padrao: "", tipo: "texto" },
  numeroNf: { padrao: "", tipo: "texto" },
  cnpjTomador: { padrao: "", tipo: "texto" },
  pagina: { padrao: 1, tipo: "inteiro", min: 1 },
  tamanhoPagina: { padrao: 25, tipo: "inteiro", min: 10, max: 100 },
  ordenarPor: { padrao: "emissao", tipo: "enum", opcoes: ORDENACAO },
  ordem: { padrao: "desc", tipo: "enum", opcoes: ["asc", "desc"] },
};

// Chaves que contam como "filtro avançado" no contador da FilterBand.
export const CHAVES_AVANCADAS = ["chave", "numero", "serie", "transportadoraId", "tipo", "situacao", "chaveNf", "numeroNf", "cnpjTomador"];

export const TIPO_DATA_OPTIONS = [
  { value: "emissao", label: "Emissão" },
  { value: "importacao", label: "Importação" },
];

export const TIPO_OPTIONS = [
  { value: "", label: "Todos" },
  { value: "0", label: "Normal" },
  { value: "1", label: "Complementar" },
  { value: "2", label: "Anulação" },
  { value: "3", label: "Substituto" },
];

export const SITUACAO_OPTIONS = [
  { value: "", label: "Todas" },
  { value: "ativo", label: "Sem cancelamento" },
  { value: "cancelado", label: "Cancelado na SEFAZ" },
];

export const TIPO_TONE = { 0: "neutral", 1: "info", 2: "danger", 3: "warning" };

// Busca direta (período ignorado) só com a chave completa ou o número; trecho
// de chave segue o período com teto de 31 dias (PO1-3904, igual à API).
export const buscaDireta = (f) => Boolean(chaveCompleta(f.chave) || (f.numero || "").trim());
export const comChaveParcial = (f) => !buscaDireta(f) && Boolean(chaveParcial(f.chave) || chaveParcial(f.chaveNf));

// Parâmetros da API: filtros ativos + escopo. `paraExportar` tira a paginação
// (a exportação sempre leva a consulta inteira, com a mesma ordenação).
export function paramsDaApi(filtros, { embarcadorId, transportadoraId } = {}, { paraExportar = false } = {}) {
  const ativos = filtrosAtivos(filtros, DEFINICAO_FILTROS);
  const params = {
    ...ativos,
    ordenarPor: filtros.ordenarPor || DEFINICAO_FILTROS.ordenarPor.padrao,
    ordem: filtros.ordem || DEFINICAO_FILTROS.ordem.padrao,
  };
  if (paraExportar) {
    delete params.pagina;
    delete params.tamanhoPagina;
  } else {
    params.pagina = filtros.pagina || 1;
    params.tamanhoPagina = filtros.tamanhoPagina || DEFINICAO_FILTROS.tamanhoPagina.padrao;
  }
  if (embarcadorId) params.embarcadorId = embarcadorId;
  // A transportadora do cabeçalho vence a do filtro (a API recusa divergência).
  if (transportadoraId) params.transportadoraId = transportadoraId;
  return params;
}
